import { connect } from 'react-redux'

import QAServicingCard from '../../components/qa-servicings/qa-servicing-card'

function mapStateToProps (state, ownProps) {
  const qaServicing = state.qaServicings[ownProps.id]
  const area = state.areas[qaServicing.area]

  return {
    qaServicing,
    qaWorkOrderId: ownProps.qaWorkOrderId,
    area
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(QAServicingCard)



// WEBPACK FOOTER //
// ./src/containers/qa-servicings/qa-servicing-card-container.js